import React from 'react';

const TransactionTable = ({ transactions, isLoading }) => {
    if (isLoading) return <p>Loading transactions...</p>;
    
    return (
        <div className="overflow-x-auto bg-white rounded-lg shadow">
            <table className="min-w-full divide-y divide-gray-200">
                <thead className="bg-gray-50">
                    <tr>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Date</th>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Type</th>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Category/Description</th>
                        <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase">Amount (₹)</th>
                    </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200">
                    {transactions.map(t => (
                        <tr key={t.id}>
                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{new Date(t.date + 'T00:00:00').toLocaleDateString()}</td>
                            <td className="px-6 py-4 whitespace-nowrap text-sm"><span className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${t.type === 'income' ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'}`}>{t.type}</span></td>
                            <td className="px-6 py-4 text-sm text-gray-800">{t.category ? `${t.category}: ${t.description}` : t.description}</td>
                            <td className={`px-6 py-4 whitespace-nowrap text-right text-sm font-semibold ${t.type === 'income' ? 'text-green-600' : 'text-red-600'}`}>{t.amount.toFixed(2)}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default TransactionTable;